import React from "react";
import {
  Show,
  SimpleShowLayout,
  TextField,
  ImageField,
  BooleanField,
  useRecordContext,
  useRefresh,
  Labeled,
} from "react-admin";
import Rating from "@mui/material/Rating";
import Tooltip from "@mui/material/Tooltip";

import ContactShowActions from "./ContactShowActions";
import OrderList2 from "./OrderList2";
import ChannelField from "./ChannelField";
import { ContactCredit } from "./ContactCredit";
import {
  useContactIgProfile,
  useUpdateContact,
  useContactFbProfile,
} from "../DataHooks/useGetFbProfileImage";
import { CONTACT_CHANNEL_INSTAGRAM } from "../Constant";
import NameField from "./NameField";
import { Box, Typography } from "@mui/material";

const ContactRating = () => {
  const record = useRecordContext();
  return <Rating value={record.rating / 2} precision={0.5} readOnly />;
};

const CustomImageField = (props) => {
  const record = useRecordContext();
  const refresh = useRefresh();

  const isInstagram =
    record && record.channel && record.channel === CONTACT_CHANNEL_INSTAGRAM;
  const isFacebook = !isInstagram;

  const { trigger, isMutating, data } = useUpdateContact(record.id, {
    dedupingInterval: 15 * 60 * 1000,
    onSuccess: () => {
      refresh();
    },
  });

  const fbProfile = useContactFbProfile(isFacebook ? record.psid : "");

  const { data: igProfile } = useContactIgProfile(
    isInstagram ? record.psid : undefined,
    {
      onSuccess: (data) => {
        if (
          record.name !== data.username ||
          record.profilePic !== data.profile_pic
        ) {
          trigger({
            profilePic: data.profile_pic,
            name: data.username,
          });
        }
      },
    }
  );

  React.useEffect(() => {
    if (
      fbProfile &&
      fbProfile.name &&
      fbProfile.name.toLowerCase() !== "facebook user" //sometimes FB conversation API returns "Facebook User"
    ) {
      if (
        record.name !== fbProfile.name ||
        record.profilePic !== fbProfile.profile_pic
      ) {
        trigger({
          profilePic: fbProfile.profile_pic,
          name: fbProfile.name,
        });
      }
    }
  }, [fbProfile]);

  return (
    <ImageField
      {...props}
      source="profilePic"
      title="profilePic"
      sx={{
        "& .RaImageField-image": {
          width: 140,
          height: 140,
        },
      }}
    />
  );
};

const VipTierField = () => (
  <Box display="flex" alignItems="center">
    <Labeled label="VIP Tier (Priority Level)">
      <TextField source="vipTier" label="VIP Tier (Priority Level)" />
    </Labeled>
    <Tooltip
      title={
        <Typography sx={{ fontSize: "14px" }}>
          VIP Tier represents the contact's priority level. Higher tiers unlock
          more exclusive products. A tier 3 contact can order tier 3 and below
          but not tier 4.
        </Typography>
      }
    >
      <Typography
        variant="body2"
        sx={{
          cursor: "pointer",
          marginLeft: "4px",
          fontWeight: "bold",
          color: "gray",
          border: "1px solid gray",
          borderRadius: "50%",
          width: "16px",
          height: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "12px",
        }}
      >
        ?
      </Typography>
    </Tooltip>
  </Box>
);

const ContactShow = (props) => {
  return (
    <Show actions={<ContactShowActions />} title="Contact" {...props}>
      <SimpleShowLayout>
        <CustomImageField source="profilePic" />
        {/* <TextField source="name" /> */}
        <NameField source="name" />
        <BooleanField source="isBlacklisted" />
        <TextField source="remarks" />
        <TextField source="phoneNumber" />
        <ChannelField source="channel" label="Channel" />
        <ContactRating label={`Rating`} />
        <ContactCredit label="Available Credit" />
        <VipTierField />
        <TextField source="psid" />
        <OrderList2 />
      </SimpleShowLayout>
    </Show>
  );
};

export default ContactShow;
